import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import "../custom.css";

const AuthLayout = () => {
  const [fontSizeClassIndex, setFontSizeClassIndex] = useState(2);
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("theme") === "dark",
  );

  const fontSizeClasses = [
    "font-size-xs",
    "font-size-sm",
    "font-size-md",
    "font-size-lg",
    "font-size-xl",
  ];

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
      document.body.classList.remove("light-mode");
    } else {
      document.body.classList.add("light-mode");
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  useEffect(() => {
    document.body.classList.remove(...fontSizeClasses);
    document.body.classList.add(fontSizeClasses[fontSizeClassIndex]);
  }, [fontSizeClassIndex]);

  return (
    <div className="main-content-area">
      <Outlet />
    </div>
  );
};

export default AuthLayout;
